import React from 'react';
import {DialogActions, DialogContent, DialogTitle} from 'material-ui/Dialog';
import {Button, InputLabel, TextField, withStyles} from 'material-ui';
import MapLocationField from '../map_location_field';
import {EditDialog} from '../../../../components/edit-dialog/edit_dialog';
import {styles} from '../../style/map_section';
import SimpleEditor from '../../../../components/editor/simple_editor';
import Select from 'react-select';

class MapSectionEditPopup extends React.Component {
    render() {
        let {
            open,
            title,
            body,
            instructions,
            locations,
            onHandleRequestClose,
            onUpdateTitleField,
            onUpdateInstructionsField,
            onUpdateBodyField,
            onHandleRequestDone,
            onUpdateLocationField,
            classes,
            sectionSettings,
            selectedSectionSettings,
            selectSectionSetting,
        } = this.props;

        locations = locations
            ? locations.filter((l) => l.deleted === false)
            : [];

        const collapsibleSetting = sectionSettings.find(
            setting => setting.machine_name === 'section-collapse'
        );
        const selectedCollapseSetting = selectedSectionSettings.find(
            setting => setting.machine_name === 'section-collapse'
        );
        const selectedCollapseOptionId = selectedCollapseSetting
            ? selectedCollapseSetting.options[0].id : '';

        return (
            <EditDialog
                open={open}
                classes={{
                    paper: classes.paper,
                    fullWidth: classes.fullWidth,
                }}
            >
                <DialogTitle>Edit Map Section</DialogTitle>
                <DialogContent>
                    <TextField
                        autoFocus
                        margin="dense"
                        id="title"
                        label="Title"
                        onChange={(event) => {
                            onUpdateTitleField(event.target.value);
                        }}
                        fullWidth
                        value={title || ''}
                    />

                    <InputLabel className="simpleEditorLabelPages">
                        Intro text
                    </InputLabel>
                    <SimpleEditor
                        initialValue={body}
                        onChange={(htmlBody) => {
                            onUpdateBodyField(htmlBody);
                        }}
                    />

                    <TextField
                        multiline
                        margin="dense"
                        id="instructions"
                        label="Instructions"
                        onChange={(event) => {
                            onUpdateInstructionsField(event.target.value);
                        }}
                        fullWidth
                        value={instructions || ''}
                    />

                    {locations.map((location, i) => {
                        return (
                            <MapLocationField
                                key={i}
                                onUpdateSectionLocation={(
                                    locationId,
                                    newDescription
                                ) => {
                                    onUpdateLocationField(
                                        locationId,
                                        newDescription
                                    );
                                }}
                                locationId={location.location_id}
                                label={location.city}
                                description={location.description}
                            />
                        );
                    })}

                    {collapsibleSetting &&
                        <Select
                            style={{ marginTop: '10px' }}
                            name="collapsible-select"
                            value={selectedCollapseOptionId}
                            onChange={selectedOption => selectSectionSetting(selectedOption, collapsibleSetting)}
                            options={collapsibleSetting.options}
                            clearable={false}
                            labelKey={'option'}
                            valueKey={'id'}
                            placeholder="Select Collapsible Type"
                            className="React-select-larger-font"
                    />}

                </DialogContent>
                <DialogActions className={classes.dialogActionsBtn}>
                    <Button
                            variant="raised"
                            onClick={(ev) => onHandleRequestDone(ev)}
                            color="primary"
                        >
                        Done
                    </Button>
                    <Button
                        variant="raised"
                        onClick={(ev) => onHandleRequestClose(ev)}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </EditDialog>
        );
    }
}

export default withStyles(styles)(MapSectionEditPopup);



// WEBPACK FOOTER //
// ./src/containers/builder/form/popups/map_section_edit.js